import { CommonModule } from "@angular/common";
import {
  Component,
  Input,
  OnDestroy,
  ViewChild,
  ElementRef,
  AfterViewInit,
} from "@angular/core";

@Component({
  selector: "app-carousel",
  imports: [CommonModule],
  templateUrl: "./carousel.component.html",
  styleUrl: "./carousel.component.scss",
})
export class CarouselComponent implements AfterViewInit, OnDestroy {
  @Input() autoPlayInterval: number = 0;
  @Input() showDots: boolean = true;
  @Input() enableSwipe: boolean = true;

  @ViewChild("carouselTrack", { static: false }) carouselTrack?: ElementRef;

  currentIndex = 0;
  totalSlides = 0;
  private autoPlayTimer?: any;
  private touchStartX = 0;
  private touchEndX = 0;

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.updateSlideCount();
      if (this.autoPlayInterval > 0) {
        this.startAutoPlay();
      }
    }, 0);
  }

  ngOnDestroy(): void {
    this.stopAutoPlay();
  }

  private updateSlideCount(): void {
    if (this.carouselTrack) {
      const slides =
        this.carouselTrack.nativeElement.querySelectorAll(".carousel-slide");
      this.totalSlides = slides.length;
    }
  }

  goToSlide(index: number): void {
    if (index >= 0 && index < this.totalSlides) {
      this.currentIndex = index;
      this.resetAutoPlay();
    }
  }

  nextSlide(): void {
    this.currentIndex = (this.currentIndex + 1) % this.totalSlides;
    this.resetAutoPlay();
  }

  previousSlide(): void {
    this.currentIndex =
      this.currentIndex === 0 ? this.totalSlides - 1 : this.currentIndex - 1;
    this.resetAutoPlay();
  }

  private startAutoPlay(): void {
    this.autoPlayTimer = setInterval(() => {
      this.nextSlide();
    }, this.autoPlayInterval);
  }

  private stopAutoPlay(): void {
    if (this.autoPlayTimer) {
      clearInterval(this.autoPlayTimer);
    }
  }

  private resetAutoPlay(): void {
    if (this.autoPlayInterval > 0) {
      this.stopAutoPlay();
      this.startAutoPlay();
    }
  }

  onTouchStart(event: TouchEvent): void {
    if (!this.enableSwipe) return;
    this.touchStartX = event.touches[0].clientX;
  }

  onTouchEnd(event: TouchEvent): void {
    if (!this.enableSwipe) return;
    this.touchEndX = event.changedTouches[0].clientX;
    this.handleSwipe();
  }

  onMouseDown(event: MouseEvent): void {
    if (!this.enableSwipe) return;
    this.touchStartX = event.clientX;
  }

  onMouseUp(event: MouseEvent): void {
    if (!this.enableSwipe) return;
    this.touchEndX = event.clientX;
    this.handleSwipe();
  }

  private handleSwipe(): void {
    const swipeThreshold = 50;
    const diff = this.touchStartX - this.touchEndX;

    if (Math.abs(diff) > swipeThreshold) {
      if (diff > 0) {
        this.nextSlide();
      } else {
        this.previousSlide();
      }
    }
  }

  get dots(): number[] {
    return Array.from({ length: this.totalSlides }, (_, i) => i);
  }
}
